import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { COLOR_PALLETTE } from 'Globals/Constants'
import { de, fr } from 'Globals/Locale'
import { SwissMap } from 'components/ChoroplethMap'
import { NameTable } from 'components/NameTable'
import ToolTip from 'components/ToolTip/ToolTip'
import { useContext, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import chTopoJson from '../ChoroplethMap/Assets/municipalities_topo_2023.json'
import data from '../ChoroplethMap/Assets/municipalities_old.json'
import { useEventListener } from 'usehooks-ts'
import GlobalContext from 'Contexts/GlobalContext'
import { Loader } from 'components/Loader'

export const MapWrapper = ({
  tenant,
  handleSortChange,
}: {
  tenant: Tenant
  handleSortChange: (s: 'rel' | 'abs') => void
}) => {
  const [nameMinMax, setNameMinMax] = useState({
    abs: { min: 0, max: 1 },
    rel: { min: 0, max: 1 },
  })
  const [rawNameData, setRawNameData] = useState<any>()
  const [verzeichnis, setVerzeichnis] = useState<any>(
    window.nachnamen.verzeichnis ? window.nachnamen.verzeichnis : undefined
  )
  const [prepedName, setPrepedName] = useState<MunicipalityDataElement[]>()
  const [useRelative, setUseRelative] = useState<boolean>(true)
  const [activeMunicipalityId, setActiveMunicipalityId] = useState<number>()
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false)
  const [foundMunicipalityFromUrl, setFoundMunicipalityFromUrl] =
    useState(false)
  const currentLocale = tenant?.lang === 'fr' ? fr : de
  const [currentName, setCurrentName] = useState<CurrentName>(
    window.nachnamen.currentName
      ? window.nachnamen.currentName
      : {
          abs: 37,
          id: 's57',
          incollection: true,
          name: 'Orlik',
          rel: 0.001,
        }
    // : {
    //     abs: 53300,
    //     id: '0.json',
    //     incollection: false,
    //     name: 'Müller',
    //     rel: 0.8569625068,
    //   }
  )
  const { locale } = useContext(GlobalContext) ?? { locale: de }
  useEventListener('verzeichnis_loaded' as any, () => {
    console.log(
      'verzeichnis_loaded',
      window.nachnamen.verzeichnis,
      window.nachnamen.verzeichnis?.find(
        (f: { name: string }) => f.name.toLowerCase() === 'Orlic'
      )
    )

    setVerzeichnis(window.nachnamen.verzeichnis)
  })
  useEventListener('name_changed' as any, () => {
    if (!window.nachnamen || !verzeichnis) return

    setCurrentName(
      window.nachnamen.currentName as {
        id: number | string
        name: string
        [key: string]: any
      }
    )
  })
  const activeMunicipality = data.find(
    (muni) => muni.GDENR === activeMunicipalityId
  )
  const activeMunicipalityData = prepedName?.find(
    (muni) => muni.bfsId === activeMunicipalityId
  )

  function prepNameData(data: any) {
    if (!currentName) return
    // if (currentName.incollection) {
    //   data = data[currentName.name]
    // }
    const { gde, max, min, rel_min, rel_max } = data
    setNameMinMax({ abs: { min: 3, max }, rel: { min: rel_min, max: rel_max } })
    const preped = Object.entries(gde).map(([bfsid, vals]: any) => {
      return { ...vals, bfsId: +bfsid }
    })

    return preped
  }

  useEffect(() => {
    if (!rawNameData) return

    setPrepedName(prepNameData(rawNameData))
  }, [rawNameData])
  useEffect(() => {
    if (!handleSortChange) return
    handleSortChange(useRelative ? 'rel' : 'abs')
  }, [useRelative])


  const url='interaktiv-mf.tagesanzeiger.ch/2026/etl-nachnamen/' 
  // const url='https://interaktiv.tagesanzeiger.ch/2025/nachnamen/' 
  useEffect(() => {
    if (!currentName || !verzeichnis) return
    var fromVerzeichnis = verzeichnis.find(
      (f: { name: string }) =>
        f.name.toLowerCase() === currentName.name.toLowerCase()
    )
    if (!fromVerzeichnis) {
      setPrepedName(undefined)
      return
    }
    console.log(
      'fetching aa',
      fromVerzeichnis.id,
      verzeichnis.find(
        (f: { name: string }) => f.name.toLowerCase() === 'orlik'
      )
    )
    console.log(url + fromVerzeichnis.id + '.json',fromVerzeichnis)
    fetch(
      url +
        fromVerzeichnis.id +
        '.json'
    )
      .then((e) => e.json())
      .then((e) => {
        if (e[currentName.name]) {
          setRawNameData(e[currentName.name])
        } else {
          setRawNameData(e)
        }
      })
  }, [currentName, verzeichnis])

  return (
    <>
      {!verzeichnis && <Loader />}
      {!prepedName && verzeichnis && <MapHint>{locale.nomapdata}</MapHint>}
      {prepedName && <MapTitle>{locale.maptitle_1}{currentName.name}{locale.maptitle_2}</MapTitle>}
      {chTopoJson && prepedName && currentName && (
        <MapSection>
          <Title>{locale.maptitle}</Title>
          <SwissMap
            currentDataType={useRelative}
            dataTypeSwitch={setUseRelative}
            zoomIntoActiveMunicipality={true}
            locale={tenant.lang}
            propertyNameToCompare={useRelative ? 'rel' : 'abs'}
            municipalityData={prepedName}
            minValue={nameMinMax[useRelative ? 'rel' : 'abs'].min}
            maxValue={nameMinMax[useRelative ? 'rel' : 'abs'].max}
            topoJsonYear={2024}
            // topoJson={chTopoJson}
            colorPalette={COLOR_PALLETTE}
            currentName={currentName.name}
            newActiveMunicipalityIdHandler={(muniId) => {
              setActiveMunicipalityId(muniId)
            }}
            // hideMunicipalitySearch={true}
            municipalitySearchYear={'20240101'}
            activeMunicipalityId={activeMunicipalityId}
            ToolTip={ToolTip}
            isFullscreen={isFullscreen}
            fullscreenChangeHandler={(isFullscreenNewVal) => {
              setIsFullscreen(isFullscreenNewVal)
            }}
            scrollIntoView={!foundMunicipalityFromUrl}
            sort={useRelative ? 'rel' : 'abs'}
          />

          {activeMunicipality && activeMunicipalityData && (
            <ToolTipWrapper isFullscreen={isFullscreen}>
              <ToolTip
                activeData={activeMunicipalityData}
                currentName={currentName.name}
                propertyName={useRelative ? 'rel' : 'abs'}
                sort={useRelative ? 'rel' : 'abs'}
              />
            </ToolTipWrapper>
          )}
          {prepedName && (
            <TextWidth>
              <div
                className='nametable'
                style={{
                  maxWidth: '668px',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <NameTable
                  sorttype={useRelative ? 'rel' : 'abs'}
                  nameData={prepedName}
                  currentLocale={currentLocale}
                />
              </div>
            </TextWidth>
          )}
        </MapSection>
      )}
    </>
  )
}

const MapTitle = styled.h2`
  text-align: center;
  margin-bottom: 10px;
  line-height: 1.4em;
  margin-bottom: 15px;
`
// const LoaderContainer = styled.div`
//   text-align: center;
//   max-width: 450px;
//   font-size: 12px;
//   margin-left: auto;
//   margin-right: auto;
//   line-height: 1.4em;
//   margin-bottom: 30px;
//   margin-top: 120px;
//   color: var(--gray-3);
//   @media screen and (max-width: 711px) {
//     max-width: calc(100vw - 30px);
//   }
// `
// const Loader = styled.div`
//   width: 16px;
//   height: 16px;
//   border-radius: 50%;
//   background-color: var(--text-color);
//   box-shadow: 32px 0 var(--text-color), -32px 0 var(--text-color);
//   position: relative;
//   animation: flash 0.3s ease-in infinite alternate;
// transform: scale(0.3);
//   margin-left: auto;
//   margin-right: auto;
//   margin-top: 30px;
//   &::before,
//   &::after {
//     content: '';
//     position: absolute;
//     left: -64px;
//     top: 0;
//     background: var(--text-color);
//     width: 16px;
//     height: 16px;
//     border-radius: 50%;
//     transform-origin: 35px -35px;
//     transform: rotate(45deg);
//     animation: hitL 0.3s ease-in infinite alternate;
//   }

//   &::after {
//     left: 64px;
//     transform: rotate(-45deg);
//     transform-origin: -35px -35px;
//     animation: hitR 0.3s ease-out infinite alternate;
//   }

//   @keyframes flash {
//     0%,
//     100% {
//       background-color: rgba(100, 100, 100, 0.25);
//       box-shadow: 32px 0 rgba(100, 100, 100, 0.25),
//         -32px 0 rgba(100, 100, 100, 0.25);
//     }
//     25% {
//       background-color: rgba(100, 100, 100, 0.25);
//       box-shadow: 32px 0 rgba(100, 100, 100, 0.25),
//         -32px 0 rgba(100, 100, 100, 1);
//     }
//     50% {
//       background-color: rgba(100, 100, 100, 1);
//       box-shadow: 32px 0 rgba(100, 100, 100, 0.25),
//         -32px 0 rgba(100, 100, 100, 0.25);
//     }
//     75% {
//       background-color: rgba(100, 100, 100, 0.25);
//       box-shadow: 32px 0 rgba(100, 100, 100, 1),
//         -32px 0 rgba(100, 100, 100, 0.25);
//     }
//   }

//   @keyframes hitL {
//     0% {
//       transform: rotate(45deg);
//       background-color: rgba(100, 100, 100, 1);
//     }
//     25%,
//     100% {
//       transform: rotate(0deg);
//       background-color: rgba(100, 100, 100, 0.25);
//     }
//   }

//   @keyframes hitR {
//     0%,
//     75% {
//       transform: rotate(0deg);
//       background-color: rgba(100, 100, 100, 0.25);
//     }
//     100% {
//       transform: rotate(-45deg);
//       background-color: rgba(100, 100, 100, 1);
//     }
//   }
// `

const Title = styled.div`
  text-align: center;
  margin-bottom: 10px;
  line-height: 1.4em;
  margin-bottom: 15px;
  font-size: 14px;
`

const MapHint = styled.div`
  max-width: 450px;
  font-size: 12px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.4em;
  margin-bottom: 30px;
  color: var(--gray-3);
  @media screen and (max-width: 711px) {
    max-width: calc(100vw - 30px);
  }
`

const MapSection = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 30px;
  position: relative;

  @media (min-width: 768px) {
    min-height: 523px;
  }
  #swiss-choropleth-map {
    path {
      transition: fill 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
    svg {
      #country-border {
        /* fill: url(#diagonalHatch); */
        vector-effect: non-scaling-stroke;
      }
      .active-municipality {
        stroke: var(--text-color);
        stroke-width: 1px;
      }
      .municipality {
        // only hover on desktop
        @media (hover: hover) {
          &:hover {
            stroke: white;
            stroke-width: 1.5px;
          }
        }
      }
    }
  }
`
const ToolTipWrapper = styled.div<{ isFullscreen: boolean }>`
  pointer-events: none;
  margin-bottom: 30px;
  position: relative;
  z-index: 102;
  ${({ isFullscreen }) =>
    isFullscreen &&
    css`
      /* @media (max-width: 768px) { */
      left: 0.5em;
      right: 0.5em;
      position: sticky;
      bottom: 60px;
      /* } */
    `}
`
